export default "__VITE_ASSET__CAo0M4p$__"